import { Show } from "solid-js";
import c from "class-c";

import Button from "@repo/ui/buttons/Button";
import LoadableButton from "@repo/ui/buttons/LoadableButton";
import Line from "@repo/ui/decoration/Line";
import GoogleSignIn from "@repo/ui/external/GoogleSignIn";
import Form from "@repo/ui/inputs/Form";

import appSettings from "~/appSettings";

import styles from "./AuthButtons.module.scss";

declare namespace AuthButtons {
  type Props = {
    submittable: boolean;
    acknowledged?: boolean;
    text: LoadableButton.Props["text"] & { initial: string };
    onClick?: () => void;
  };
}

function AuthButtons({
  submittable,
  acknowledged = true,
  text,
  onClick,
}: D<AuthButtons.Props>) {
  return (
    <div class={c`${styles["auth-buttons"]} mt-3`} onClick={onClick}>
      <Form.Submit
        as={Button}
        variant="primary-hard"
        size="full-width"
        class={c`${styles["submit-button"]} ${(!submittable || !acknowledged) && "disabled"}`}
        text={text}
      >
        {text.initial}
      </Form.Submit>
      <Show when={appSettings.auth.googleSso}>
        <Line class={styles.line}>or</Line>
        <GoogleSignIn.Button
          disabled={!acknowledged}
          class={c`${!acknowledged && "disabled"}`}
        />
      </Show>
    </div>
  );
}

export default AuthButtons;
